/** 从导航菜单树取第一个可访问页面 path */
export function firstMenuPath(menus) {
  const list = Array.isArray(menus) ? menus : []
  for (const m of list) {
    if (!m) continue
    if (m.type === 1 && m.path) return m.path
    const kids = (m.children || []).filter(c => c && c.type === 1 && c.path)
    if (kids.length) return kids[0].path
  }
  return null
}

/** 是否拥有指定菜单 path 或 perms */
export function hasMenuAccess(menus, { path, perms } = {}) {
  const walk = (list) => {
    for (const m of list || []) {
      if (!m) continue
      if (path && m.path === path) return true
      if (perms && m.perms === perms) return true
      if (m.children && walk(m.children)) return true
    }
    return false
  }
  return walk(menus)
}

/** 用户是否包含指定角色（多角色：包含即命中） */
export function userHasRole(user, code) {
  if (!user || !code) return false
  const want = String(code).toUpperCase()
  const codes = Array.isArray(user.roleCodes) ? user.roleCodes : []
  if (codes.some(c => String(c || '').toUpperCase() === want)) return true
  return String(user.roleCode || '').toUpperCase() === want
}

export function isSupplierUser(user) {
  if (!user) return false
  return !!(user.supplierId || userHasRole(user, 'SUPPLIER'))
}
